import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";
import { CSSProperties } from "react";
import styled from "styled-components";

export const StyledInput = styled.input`
  font-size: 60px;
  font-weight: 500;
  font-family: "Inter", sans-serif;
  font-optical-sizing: auto;
  font-style: normal;
  font-variation-settings: "slnt" 0;
  padding: 8px;
  border: none;
  border-radius: 4px;
  text-align: center;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: textfield;
  appearance: none;

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const useStyles = () => {
  const { theme } = useTheme();
  const styles: Record<string, CSSProperties> = {
    input: {
      backgroundColor: theme.background,
      color: theme.text.default,
    },
    container: {
      display: "flex",
      justifyContent: "center",
    },
    availableBalance: {
      color: theme.text.secondary,
      marginLeft: spacing.xxs,
    },
    pillText: {
      fontWeight: 500,
    },
    pillOptionsRow: {
      justifyContent: "center",
      gap: 16,
      width: "100%",
      display: "flex",
    },
    pillOption: {
      userSelect: "none",
      display: "flex",
      alignItems: "center",
      borderRadius: constants.radius.button,
      padding: "12px 20px",
      fontFamily: "Inter, sans-serif",
      fontWeight: 500,
      fontSize: 18,
      backgroundColor: theme.input.background,
      cursor: "pointer",
    },
    pillArrow: {
      marginLeft: 8,
      marginTop: -4,
    },
    pillOptionDisabled: {
      opacity: 0.5,
      cursor: "not-allowed",
      pointerEvents: "none",
    },
    button: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    error: {
      color: theme.text.error,
      textAlign: "center",
    },
  };

  return styles;
};
